export function formatString(input?: string | null): string {
  if (!input) return ''

  return input
    .split('_')
    .map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : ''))
    .join(' ')
}
